import { Component, Input, OnInit } from '@angular/core';
import { BlockLifemap } from '@shared/models/step.model';
import { LifemapType, PlEventColor, plEventsColor } from '@shared/services/lifemap/lifemap.service';
import { PlIcon } from '@app/icon-library/icons';

@Component({
  selector: 'pl-lifemap-help',
  templateUrl: './lifemapHelp.component.html',
})
export class LifemapHelpComponent implements OnInit {
  @Input({ required: true }) public blockLifemap!: BlockLifemap;

  protected readonly LifemapType: typeof LifemapType = LifemapType;
  protected readonly PlIcon: typeof PlIcon = PlIcon;
  protected readonly plEventsColor: Record<LifemapType, PlEventColor> = plEventsColor;

  public lifemapTips: string[] = [];

  public ngOnInit(): void {
    console.log('TONIO LifemapHelpComponent ngOnInit this.blockLifemap=', this.blockLifemap);
    this.lifemapTips = this.blockLifemap.data.config.help.tips.filter((tip: string | null): tip is string => {
      return !!tip;
    });
  }
}
